import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';

const SelectFuncaoModal = ({ show, onHide, funcoes, onSelect }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Selecionar Função de Outro Mês</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ListGroup>
                    {funcoes.map((funcao) => (
                        <ListGroup.Item 
                            key={funcao.id} 
                            action 
                            onClick={() => onSelect(funcao)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <strong>{funcao.nome_funcao}</strong>
                                    <div className="text-muted">
                                        Mês: {funcao.mes_ano}
                                    </div>
                                </div>
                                <div className="text-end">
                                    <div>Horas: {funcao.horas_funcao}</div>
                                    <div>Taxa: {funcao.custo_venda_funcao}</div>
                                </div>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SelectFuncaoModal; 